import api from '@trinsly/common/src/services/api'

export type GetSignatureServiceProps = {}

export default async function getUserSignatureService({}: GetSignatureServiceProps) {
  return api('/signature', {
    method: 'GET',
  })
}
